import React, { useState } from 'react';
import { Modal } from 'antd';
import EditCircuitoForm from './EditCircuitoForm';

const EditCircuitoModal = ({ visible, circuito, onCancel, onSuccess }) => {
  return (
    <Modal
      title="Editar Circuito"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      <EditCircuitoForm
        circuito={circuito}
        onSuccess={() => {
          onSuccess();
          onCancel();
        }}
        onCancel={onCancel}
      />
    </Modal>
  );
};

export default EditCircuitoModal;